import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography } from 'antd';
import store from 'store';
import MobileHeader from '../../../components/mobile/Header';
import { ReactComponent as DoctorSvg } from '../../../assets/icons/doctor.svg';
import { ReactComponent as HearthSvg } from '../../../assets/icons/hearth.svg';
import ButtonFooter from '../../../components/mobile/ButtonFooter';
import { LOCAL_STORAGE_AUTH_KEY } from '../../../config/constants';

const { Title } = Typography;

const styles = {
  title: {
    color: '#404047',
    fontWeight: '400',
    fontSize: '20px',
    margin: 0
  },
  subtitle: {
    color: '#15A9E1',
    fontSize: 14,
    textAlign: 'center',
    fontWeight: '300'
  },
  itemTitle: {
    fontSize: 14,
    lineHeight: '17px',
    textAlign: 'center',
    fontWeight: '400',
    color: '#404047',
    marginBottom: 0
  },
  box: {
    background: '#FFFFFF',
    border: '1px solid #F4F4F4',
    borderRadius: 5,
    marginRight: 12,
    marginBottom: 12,
    minHeight: 150
  },
  circle: {
    width: 102,
    height: 102,
    backgroundColor: '#E7E7E7',
    borderRadius: '50%',
    margin: '0 auto',
    marginBottom: 20
  }
};

function MobileReasonScreen() {
  const { t } = useTranslation(['common', 'welcome']);
  const history = useHistory();

  const checkAlreadySignUpFirstVisitor = () => {
    const guestId = store.get(LOCAL_STORAGE_AUTH_KEY.GUEST_ID);
    if (guestId === undefined) {
      history.push('/sign-in');
    }
  }

  const data = [
    {name: t('welcome:reason.speakToDoctor'), icon: <DoctorSvg />, url: '/speak-doctor'},
    {name: t('welcome:reason.getHealthInformation'), icon: <HearthSvg />, url: '/homepage-guest'},
  ];

  useEffect(() => {
    checkAlreadySignUpFirstVisitor()
  }, [])

  const createProfile = () => {
    history.push('/sign-up/guest/method');
  }

  const renderAvatar = (item) => {
    return (
      <Col xs={12} onClick={() => history.push(item.url)} style={{ cursor: "pointer" }}>
        <Box paddingY={12} paddingX={18} style={styles.box}>
          {
            item.icon !== null
            ? (
              <Box textAlign="center" style={{ marginBottom: 15 }}>
                {item.icon}
              </Box>
            )
            : (
              <Box style={styles.circle} />
            )
          }
          <Title level={4} style={styles.itemTitle}>
            {item.name}
          </Title>
        </Box>
      </Col>
    )
  }

  return (
    <>
      <MobileHeader />
      <Box paddingTop={30} paddingBottom={12} paddingX={20}>
        <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
          <Col>
            <Title level={4} style={styles.title}>
              {t('welcome:getStarted.title')}
            </Title>
            <p style={styles.subtitle}>
              {t('welcome:login.whatYouTodo')}
            </p>
          </Col>
        </Row>
        <Row>
          {data.map((item) => renderAvatar(item))}
        </Row>
      </Box>
      <ButtonFooter
        title={t('welcome:signIn.createProfile')}
        onClick={createProfile}
      />
    </>
  );
}

export default MobileReasonScreen;
